import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogHeader } from "./ui/dialog";

export const KeyboardShortcutsDialog: React.FC<{
	open: boolean;
	onClose: () => void;
}> = ({ open, onClose }) => {
	const shortcuts = [
		{ keys: "Ctrl/Cmd + K", description: "Suche öffnen" },
		{ keys: "Ctrl/Cmd + J", description: "Neuen Auftrag erstellen" },
		{
			keys: "Ctrl/Cmd + D",
			description: "Auftragsdokument in Auftrag öffnen",
		},
		{ keys: "Ctrl/Cmd + Enter", description: "Nachricht direkt senden" },
		{
			keys: "Ctrl/Cmd + C",
			description: "Ausgewählte Positionen kopieren",
		},
		{
			keys: "Ctrl/Cmd + X",
			description: "Ausgewählte Positionen ausschneiden",
		},
		{
			keys: "Ctrl/Cmd + V",
			description: "Ausgewählte Positionen einfügen",
		},
	];

	return (
		<Dialog open={open} onOpenChange={(open: boolean) => !open && onClose()}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Tastenkürzel</DialogTitle>
				</DialogHeader>
                <div className="space-y-2 w-[90vw] max-w-[400px]">
					{shortcuts.map((s) => (
						<div key={s.keys} className="flex justify-between">
							<span className="font-mono text-sm">{s.keys}</span>
							<span className="text-sm">{s.description}</span>
						</div>
					))}
				</div>
			</DialogContent>
		</Dialog>
	);
};
